import { Model } from '@/services/api/lib'

class TaxRate extends Model {
  resource () {
    return 'taxes/v1/rates'
  }

  updateMethod () {
    return 'PUT'
  }

  validations () {
    return {
      name: 'required|string',
      rate: 'required|number'
    }
  }
}

class TaxGroup extends Model {
  resource () {
    return 'taxes/v1/groups'
  }

  updateMethod () {
    return 'PUT'
  }

  validations () {
    return {
      name: 'required|string',
      zone_code: 'required',
      rates: 'required',
      tax_rate_ids: 'required',
      shipping_taxable: 'required|boolean'
    }
  }
}

class VAT extends Model {
  resource () {
    return 'taxes/v1/vat'
  }

  updateMethod () {
    return 'PUT'
  }

  validations () {
    return {
      name: 'required|string',
      value: 'required|number'
    }
  }

  defaults () {
    return {
      name: '',
      value: 0,
      product_ids: [],
      shipping_ids: [],
      translations: null
    }
  }
}

export {
  TaxRate,
  TaxGroup,
  VAT
}
